import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { forkJoin } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { IndividualPEP, BeneficialOwnerPEP } from 'src/app/modules/pep-list/pep-list.interface';
import { PepListService } from 'src/app/modules/pep-list/pep-list.service';
import * as PepListActions from './pep-list.actions';

@Injectable()
export class PepListEffects {
  loadPEPList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PepListActions.loadPEPList),
      switchMap(() => {
        return forkJoin([
          this.pepService.getIndividualsPEPList(),
          this.pepService.getBeneficialOwnersPEPList({ status: ['NONE', 'UNKNOWN'] })
        ]).pipe(
          map(([individualPEPList, beneficialOwnerPEPList]: [BackendResponse<IndividualPEP>, BackendResponse<BeneficialOwnerPEP>]) => {
            return PepListActions.setPEPList({
              individualPepList: individualPEPList.results,
              beneficialOwnerPEPList: beneficialOwnerPEPList.results
            });
          })
        );
      })
    )
  );

  constructor(private actions$: Actions, private pepService: PepListService) {}
}
